import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getDailyUsageAction,
  getDailyUsageByDateAction,
  createDailyUsageAction,
  updateDailyUsageAction,
} from "./dailyUsageSliceActions";
import { dailyUsageSliceInitialState } from "./dailyUsageSliceInitialState";

const initialState = dailyUsageSliceInitialState;

const dailyUsageSlice = createSlice({
  name: "dailyUsage",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setSelectedDayUsage: (state, action) => {
      state.selectedDayUsage = action.payload;
    },
    clearSelectedDayUsage: (state) => {
      state.selectedDayUsage = null;
    },
    resetDailyUsageState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get Daily Usage
    builder.addCase(getDailyUsageAction.fulfilled, (state, action) => {
      state.apiStatus.getDailyUsage = API_STATUS.COMPLETED;
      state.dailyUsage = action.payload;
      state.error = null;
    });
    builder.addCase(getDailyUsageAction.pending, (state) => {
      state.apiStatus.getDailyUsage = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getDailyUsageAction.rejected, (state, action) => {
      state.apiStatus.getDailyUsage = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Get Daily Usage By Date
    builder.addCase(getDailyUsageByDateAction.fulfilled, (state, action) => {
      state.apiStatus.getDailyUsageByDate = API_STATUS.COMPLETED;
      state.selectedDayUsage = action.payload;
      state.error = null;
    });
    builder.addCase(getDailyUsageByDateAction.pending, (state) => {
      state.apiStatus.getDailyUsageByDate = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getDailyUsageByDateAction.rejected, (state, action) => {
      state.apiStatus.getDailyUsageByDate = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Create Daily Usage
    builder.addCase(createDailyUsageAction.fulfilled, (state, action) => {
      state.apiStatus.createDailyUsage = API_STATUS.COMPLETED;
      state.dailyUsage.unshift(action.payload);
      state.error = null;
    });
    builder.addCase(createDailyUsageAction.pending, (state) => {
      state.apiStatus.createDailyUsage = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(createDailyUsageAction.rejected, (state, action) => {
      state.apiStatus.createDailyUsage = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update Daily Usage
    builder.addCase(updateDailyUsageAction.fulfilled, (state, action) => {
      state.apiStatus.updateDailyUsage = API_STATUS.COMPLETED;
      const index = state.dailyUsage.findIndex(
        (usage) => usage.id === action.payload.id
      );
      if (index !== -1) {
        state.dailyUsage[index] = action.payload;
      }
      if (
        state.selectedDayUsage &&
        state.selectedDayUsage.id === action.payload.id
      ) {
        state.selectedDayUsage = action.payload;
      }
      state.error = null;
    });
    builder.addCase(updateDailyUsageAction.pending, (state) => {
      state.apiStatus.updateDailyUsage = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateDailyUsageAction.rejected, (state, action) => {
      state.apiStatus.updateDailyUsage = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const {
  clearError,
  setSelectedDayUsage,
  clearSelectedDayUsage,
  resetDailyUsageState,
} = dailyUsageSlice.actions;

export default dailyUsageSlice.reducer;
